module.exports = __webpack_public_path__ + "media/images/flags/gb-sct-4743f1b0f3ffe8d16ba501687a3dc597.svg";